export const workshopServices = [
  {
    id: 'ws1',
    icon: 'ri-scissors-cut-line',
    title: 'Corte CNC',
    detail: 'Plasma (2 a 50 mm) · Oxicorte (6 a 150 mm) · Guillotina (2 a 12 mm)',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/ef283641b5c7419352db7dcb2f77d904.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/53ae37d6b8e7420aada019618c327dd3.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/e5f82aa1a0f4307c207c4a096d8622c2.png',
    ],
  },
  {
    id: 'ws2',
    icon: 'ri-arrow-down-s-line',
    title: 'Plegado',
    detail: 'De 2 hasta 8 mm de espesor',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/f62fdcc916b9eebedcbfc675920565f4.png',
    ],
  },
  {
    id: 'ws3',
    icon: 'ri-contrast-drop-line',
    title: 'Cilindrado',
    detail: 'De 2 a 40 mm de espesor',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/f3d2060043770a847fe3742fe360fc64.png',
    ],
  },
  {
    id: 'ws4',
    icon: 'ri-shapes-line',
    title: 'Prensa',
    detail: '200 toneladas de capacidad',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/1f8b24d81af81b26aba72517d5e6189f.png',
    ],
  },
  {
    id: 'ws5',
    icon: 'ri-flashlight-line',
    title: 'Soldadura MIG-TIG',
    detail: 'Alta precisión',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/1bacbb760de586ce465e4faf1e28d538.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/06fc23050ca41292e7a8a95f885d7b06.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/21d8e785d984727d5d78fe251b4cb3ad.png',
    ],
  },
  {
    id: 'ws6',
    icon: 'ri-paint-brush-line',
    title: 'Granallado y Pintura',
    detail: 'Acabado superficial profesional',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/81a40b53099d8f7358bfa65ad229ab5f.png',
    ],
  },
  {
    id: 'ws7',
    icon: 'ri-arrow-left-right-line',
    title: 'Curvado de Perfiles',
    detail: 'Perfiles estructurales y tubos',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/add848735c6c3524acdbbb48891f2d75.png',
    ],
  },
  {
    id: 'ws8',
    icon: 'ri-hammer-line',
    title: 'Preparación Perno Cable',
    detail: 'tipo 1-2-3 ; diámetro 0,6″ y 0,7″',
    images: [
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/fcebfbb0784c27b6e3db2de57df250e8.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/c6774b2ed5e895b103426ac6269686c3.png',
      'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/d6d309bfbfa3c408a971ac77f07db51a.png',
    ],
  },
];